__turbopack_context__.v({
  "Arrow": "idAXzW_Arrow",
  "ButtonContainer": "idAXzW_ButtonContainer",
  "Buttons": "idAXzW_Buttons",
  "Content": "idAXzW_Content",
  "Link": "idAXzW_Link",
  "Links": "idAXzW_Links",
  "ListItem": "idAXzW_ListItem",
  "Root": "idAXzW_Root",
  "Tagline": "idAXzW_Tagline",
  "TaglineText": "idAXzW_TaglineText",
  "Text": "idAXzW_Text",
  "Title": "idAXzW_Title",
  "TitleBottom": "idAXzW_TitleBottom",
  "TitleContainer": "idAXzW_TitleContainer",
  "TitleDesktop": "idAXzW_TitleDesktop",
  "TitleMobile": "idAXzW_TitleMobile",
  "TitleTop": "idAXzW_TitleTop",
  "Visible": "idAXzW_Visible",
});
